import { Injectable, inject } from "@angular/core";
import { Store } from "@ngxs/store";

import { RequestAuthMode } from "../shared/http-request-helper.service";
import { ConfigurationState } from "../configuration/state/configuration.state";

export type CalendarCommandMode = "create" | "extend";

@Injectable({
	providedIn: "root",
})
export class RequestAuthPolicyService {
	private store = inject(Store);

	public anonymousActionsEnabled(): boolean {
		return !!this.store.selectSnapshot(ConfigurationState.dsConfiguration)?.unauthorizedActions;
	}

	public forConfigurationFetch(asServiceUser: boolean | undefined): RequestAuthMode {
		return asServiceUser ? RequestAuthMode.ServiceUser : RequestAuthMode.User;
	}

	public forBookingRead(): RequestAuthMode {
		return RequestAuthMode.ServiceUser;
	}

	public forResourceRead(): RequestAuthMode {
		return RequestAuthMode.ServiceUser;
	}

	public forCheckInOutCommand(): RequestAuthMode {
		const dsConfig = this.store.selectSnapshot(ConfigurationState.dsConfiguration);
		return dsConfig?.unauthorizedActions ?? true
			? RequestAuthMode.ServiceUser
			: RequestAuthMode.User;
	}

	public forCalendarCommand(): RequestAuthMode {
		const dsConfig = this.store.selectSnapshot(ConfigurationState.dsConfiguration);
		return dsConfig?.unauthorizedActions && !dsConfig?.checkinOnly
			? RequestAuthMode.ServiceUser
			: RequestAuthMode.User;
	}

	public shouldRunCalendarCommandDirectly(mode: CalendarCommandMode): boolean {
		const dsConfig = this.store.selectSnapshot(ConfigurationState.dsConfiguration);
		if (mode === "create") {
			return !!dsConfig?.unauthorizedActions && !dsConfig.checkinOnly;
		}

		return !!dsConfig?.unauthorizedActions;
	}
}
